var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "catalog-layout" },
    [
      _vm.parentShowfilter === "true"
        ? _c("apartments-filters", {
            attrs: { filters: _vm.filters },
            on: { submited: _vm.onSubmit, reset: _vm.onReset }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "catalog-layout__content" },
        [
          _c(
            "div",
            { staticClass: "catalog-layout__content_head" },
            [
              _vm.parentUrl
                ? _c(
                    "a",
                    {
                      staticClass: "button-back",
                      attrs: { href: _vm.parentUrl }
                    },
                    [_vm._v("назад")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("h1", [
                _vm._v("Квартиры в ЖК «" + _vm._s(_vm.parentTitle) + "»")
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade", duration: "300" } }, [
                (_vm.sums.apartmentsTypesCount > 0) &
                (_vm.sums.apartmentsCount > 0)
                  ? _c("div", { staticClass: "numbers" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.sums.apartmentsTypesCount))
                        ]),
                        _vm._v(" "),
                        _c("small", [
                          _vm._v(
                            _vm._s(
                              _vm._f("typesCount")(
                                _vm.sums.apartmentsTypesCount,
                                true
                              )
                            ) + " "
                          ),
                          _c("br"),
                          _vm._v("квартир")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c("span", [_vm._v(_vm._s(_vm.sums.apartmentsCount))]),
                        _vm._v(" "),
                        _c("small", [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm._f("apartmentsCount")(
                                  _vm.sums.apartmentsCount,
                                  true
                                )
                              ) +
                              " в продаже\n                        "
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade", duration: "350" } }, [
            _vm.apartments.list.length == 0
              ? _c("div", { staticClass: "catalog-layout__content_empty" }, [
                  _c("p", [_vm._v("Нет результатов")])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "catalog-apartments-list" },
            [
              _c("div", { staticClass: "catalog-apartments-list__head trow" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tcol" },
                  [
                    _c("apartments-order-button", {
                      attrs: { title: "Тип", property: "rooms" },
                      on: { orderByChanged: _vm.onOrderByChanged }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tcol" },
                  [
                    _c("apartments-order-button", {
                      attrs: {
                        title: "Площадь",
                        sign: "м<sup>2</sup>",
                        property: "square"
                      },
                      on: { orderByChanged: _vm.onOrderByChanged }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tcol" },
                  [
                    _c("apartments-order-button", {
                      attrs: { title: "Корпус", property: "section" },
                      on: { orderByChanged: _vm.onOrderByChanged }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tcol" },
                  [
                    _c("apartments-order-button", {
                      attrs: { title: "Этаж", property: "floor" },
                      on: { orderByChanged: _vm.onOrderByChanged }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tcol" },
                  [
                    _c("apartments-order-button", {
                      attrs: {
                        title: "Стоимость",
                        sign: "₽",
                        property: "price"
                      },
                      on: { orderByChanged: _vm.onOrderByChanged }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "tcol" })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "catalog-apartments-list__container" },
                [
                  _c(
                    "transition-group",
                    { attrs: { name: "fade", duration: "350", tag: "div" } },
                    _vm._l(_vm.apartments.list, function(item) {
                      return _c(
                        "div",
                        {
                          key: item.url,
                          staticClass: "catalog-apartments-list__item trow"
                        },
                        [
                          _c("div", { staticClass: "tcol" }, [
                            _c("div", { staticClass: "img" }, [
                              _c("img", {
                                attrs: { src: _vm.planUrl(item.plan), alt: "" }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "tcol" }, [
                            _c("span", { staticClass: "lbl" }, [
                              _vm._v("Тип:")
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm._f("roomsCount")(item.rooms)))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "tcol" }, [
                            _c("span", { staticClass: "lbl" }, [
                              _vm._v("Площадь:")
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm._f("threeDigits")(item.square, 2)
                                  ) +
                                  " "
                              ),
                              _c("em", [_vm._v("м"), _c("sup", [_vm._v("2")])]),
                              _vm._v(" "),
                              item.balcony
                                ? _c("small", [_vm._v("Балкон")])
                                : _vm._e(),
                              _vm._v(" "),
                              item.terrace
                                ? _c("small", [_vm._v("Терраса")])
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "tcol" }, [
                            _c("span", { staticClass: "lbl" }, [
                              _vm._v("Корпус:")
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(item.section))])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "tcol" }, [
                            _c("span", { staticClass: "lbl" }, [
                              _vm._v("Этаж:")
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(item.floor))])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "tcol" }, [
                            _c("span", { staticClass: "lbl" }, [
                              _vm._v("Стоимость:")
                            ]),
                            _vm._v(" "),
                            item.price > "0"
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm._f("threeDigits")(item.price)) +
                                      " "
                                  ),
                                  _c("em", [_c("i", { staticClass: "ruble" })])
                                ])
                              : _c("span", [_vm._v("Уточнить")])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "tcol" }, [
                            _vm.parentLanding === "true"
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "button-pill lighted inline",
                                    attrs: {
                                      href:
                                        _vm.parentBaseurl +
                                        "apartament/" +
                                        item.id +
                                        "/"
                                    }
                                  },
                                  [_vm._v("Подробнее")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.parentLanding === "false"
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "button-pill lighted inline",
                                    attrs: { href: item.url }
                                  },
                                  [_vm._v("Подробнее")]
                                )
                              : _vm._e()
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade", duration: "250" } }, [
                _vm.apartments.list.length < _vm.apartments.total
                  ? _c(
                      "div",
                      { staticClass: "catalog-apartments-list__foot" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "button-pill inline",
                            class: { loading: _vm.apartments.isLoading },
                            on: {
                              click: function($event) {
                                return _vm.getNextPage()
                              }
                            }
                          },
                          [_vm._v("Загрузить ещё")]
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade", duration: "350" } }, [
        _vm.apartments.isLoading
          ? _c("div", { staticClass: "page-spinner show" }, [
              _c("span", {
                staticStyle: {
                  "background-image": "url(/images/logo-blue.svg)"
                }
              })
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tcol" }, [
      _c("span", [_vm._v("Планировка")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }